<div class="c-widget__wrapper c-vacatures-widget" id="vacatureList">
  @if (vacatureInfo.value(); as list) {
    <div class="c-widget__header u-hide@screen">
      <h2>Mijn vacatures</h2>
      @if (list.vacatures.length !== 0) {
        <div class="c-widget__header-actions">
          <div class="form-field c-widget__header-search">
            <input id="trefwoord" type="text" size="25" [formField]="trefwoordForm.trefwoord"
                   placeholder="Zoek in al mijn vacatures" (keydown.enter)="triggerTrefwoordLink()">
            <a id="trefwoordLink" href="{{trefwoordUrl()}}" class="c-btn -light action-search"
               aria-label="Zoek" rel="noopener"></a>
          </div>
          <a id="nieuweVacatureLink" href="/vac/werkgevers/vacatures/nieuw"
             class="c-btn -secundary action-add u-ml2 u-text-nowrap">Nieuwe vacature</a>
        </div>
      }
    </div>
    <div class="u-show@screen u-bb1">
      <a href="/vac/werkgevers/vacatures/nieuw" class="action-add u-display-inline u-pt1 u-pb1">Nieuwe
        vacature</a>
    </div>
    @if (list.vacatures.length === 0) {
      <div class="o-1-col">
        <div class="c-cta-block u-mt1">
          <div class="c-cta-block__container -horizontal c-empty-state-vacatures">
            <div class="c-cta-block__content">
              <h3>Je hebt nog geen vacatures aangemaakt</h3>
              <p>
                Heb je een vacature ingegeven, dan vind je ze hier terug.
              </p>
              <a href="/vac/werkgevers/vacatures/nieuw" class="c-btn c-cta-block__button">
                Maak een vacature aan
              </a>
            </div>
          </div>
        </div>
      </div>
    }
    @if (list.vacatures.length > 0) {
      <mvw-vacature-info [vacatures]=list.vacatures></mvw-vacature-info>
    }
    @if (list.vacatures.length !== 0) {
      <div>
        <a id="bekijkAlleVacaturesLink" href="/vac/werkgevers/mijnjobs"
           class="action-more-after u-mr1">Bekijk al mijn vacatures</a>
        <a id="bekijkOnvolledigeVacaturesLink" href="/vac/werkgevers/mijnjobs?showZoekDiv=true&status=ONVOLLEDIG"
           class="action-more-after u-text-co u-text-nowrap">Bekijk onvolledige vacatures</a>
      </div>
    }
  } @else if (vacatureInfo.error()) {
    <div>
      <div class="c-widget__header u-hide@screen">
        <h2>Mijn vacatures</h2>
      </div>
      <p id="errorBoodschap" class="inline-notification info" role="alert">
          <span class="action-warning">
            <span class="u-sr-only">Opgelet:</span>
          </span>
        We kunnen je vacatures momenteel niet tonen. Probeer later opnieuw.
      </p>
      <div class="c-divider"></div>
      <a id="alleVacaturesLink" href="/vac/werkgevers/mijnjobs"
         class="action-more-after u-mr1">Bekijk al mijn vacatures</a>
    </div>
  } @else {
      <div class="c-widget__header u-hide@screen">
        <h2>Mijn vacatures</h2>
        <div class="c-widget__header-actions">
          <div class="form-field c-widget__header-search">
            <input id="loadingTrefwoord" type="text" size="25" [formField]="trefwoordForm.trefwoord"
                   placeholder="Zoek in al mijn vacatures" (keydown.enter)="triggerTrefwoordLink()">
            <a id="loadingTrefwoordLink" href="{{trefwoordUrl()}}" class="c-btn -light action-search"
               aria-label="Zoek" rel="noopener"></a>
          </div>
          <a id="loadingNieuweVacatureLink" href="/vac/werkgevers/vacatures/nieuw"
             class="c-btn -secundary action-add u-ml2 u-text-nowrap">Nieuwe vacature</a>
        </div>
      </div>
      <div class="u-show@screen u-bb1">
        <a href="/vac/werkgevers/vacatures/nieuw" class="action-add u-display-inline u-pt1 u-pb1">Nieuwe
          vacature</a>
      </div>
      <mvw-loading-vacature-info></mvw-loading-vacature-info>
      <a id="loadingBekijkAlleVacaturesLink" href="/vac/werkgevers/mijnjobs"
         class="action-more-after u-mr1">Bekijk al mijn vacatures</a>
      <a id="loadingBekijkOnvolledigeVacaturesLink"
         href="/vac/werkgevers/mijnjobs?showZoekDiv=true&status=ONVOLLEDIG"
         class="action-more-after u-text-co u-text-nowrap">Bekijk onvolledige vacatures</a>
    }
</div>
